export default "__VITE_ASSET__DjlQ64ei__"